export enum InferenceLocations {
  CLIENT = 0,
  SERVER = 1,
}
